<template lang="pug">
	//- Свойства ассета Spine во вкладке ассетов: снимок анимаций и скинов скелета, переключение скинов, запуск анимаций и предпросмотр выбранного
	.spine-asset-settings
		.asset-settings-control.multi-select-control.in-a-row.low-margin.separated
			AssetCompressionData(:assetCodenames="[asset.codename]")
		.spine-asset-settings-info(v-if="spineVersion || loaded")
			span(v-if="spineVersion") Spine {{spineVersion}}
			span(v-if="loaded") {{animations.length}} {{animations.length === 1 ? 'animation' : 'animations'}}
			span(v-if="loaded") {{skins.length}} {{skins.length === 1 ? 'skin' : 'skins'}}
		.spine-asset-settings-preview
			SpinePlayer(ref="player" :json="asset.options.json" :atlas="asset.options.atlas" :imageUrl="imageUrl" :cacheKey="cacheKey" :skin="selectedSkin" :animation="selectedAnimation" :loop="loop" :playing="playing" :width="260" :height="200" v-on:loaded="onPlayerLoaded")
		.spine-asset-settings-controls(v-if="loaded && animations.length")
			.spine-asset-settings-button(v-on:click="playing = !playing" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: playing ? 'Pause' : 'Play'}")
				i.fa(:class="playing ? 'fa-pause' : 'fa-play'")
			.spine-asset-settings-button(v-on:click="restartAnimation()" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Restart animation'}")
				i.fa.fa-step-backward
			.spine-asset-settings-loop
				span.title Loop
				label.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
					input.switch-input.form-check-input(type="checkbox" :checked="loop" @change="loop = $event.target.checked")
					span.switch-slider(data-checked="On" data-unchecked="Off")
					span.switch-handle
		.spine-asset-settings-section(v-if="loaded && skins.length")
			.spine-asset-settings-section-title Skins
			.spine-asset-settings-skins
				.spine-asset-settings-skin(v-for="skin in skins" :key="skin" :class="{selected: skin === selectedSkin}" v-on:click="selectSkin(skin)") {{skin}}
		.spine-asset-settings-section(v-if="loaded && animations.length")
			.spine-asset-settings-section-title Animations
			.spine-asset-settings-animations
				.spine-asset-settings-animation(v-for="animation in animations" :key="animation.name" :class="{selected: animation.name === selectedAnimation}" v-on:click="playAnimation(animation.name)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Play animation'}")
					i.fa(:class="animation.name === selectedAnimation && playing ? 'fa-play-circle' : 'fa-play-circle-o'")
					span.spine-asset-settings-animation-name {{animation.name}}
					span.spine-asset-settings-animation-duration {{animation.duration.toFixed(2)}}s
		.spine-asset-settings-empty(v-if="loaded && !animations.length") This skeleton has no animations
</template>

<script>
	import { Asset } 				from './../../services/Asset'

	import AssetCompressionData 	from './../Templates/AssetCompressionData'
	import SpinePlayer 				from './../Dashboard/SpinePlayer'

	export default {
		name: "SpineAssetSettings",
		components: {
			AssetCompressionData,
			SpinePlayer
		},
		props: ['asset'],
		data() {

			// Последний выбор пользователя для этого ассета (только в памяти до перезагрузки страницы) - его же показывает превью при наведении
			let selection = Asset.SpineSelections[this.getSelectionKey()] || {};

			return {
				loaded: false,
				animations: [],
				skins: [],
				selectedSkin: selection.skin || null,
				selectedAnimation: selection.animation || null,
				loop: true,
				playing: true
			};

		},
		computed: {
			// url ассета Spine - текстура атласа (.png)
			imageUrl() {

				return Asset.getAssetActualUrl(this.asset);

			},
			// Ключ ассета для общего кэша разобранных скелетов Spine (см. SpinePlayer) - тот же скелет уже разобран для миниатюры ассета
			cacheKey() {

				return Asset.getSpineCacheKey(this.asset);

			},
			spineVersion() {

				let json = this.asset.options.json;

				return (_.isString(json) ? null : json?.skeleton?.spine) || null;

			}
		},
		methods: {
			getSelectionKey() {

				return `${this.asset['version_id']}-${this.asset.codename}`;

			},
			// Проигрыватель прочитал скелет: списки анимаций и скинов, а также скин и анимация, которые он выбрал по умолчанию
			onPlayerLoaded({animations, skins, animation, skin}) {

				this.animations = animations;
				this.skins = skins;

				this.selectedSkin = skin;
				this.selectedAnimation = animation;

				this.loaded = true;

			},
			selectSkin(skin) {

				this.selectedSkin = skin;

				this.saveSelection();

			},
			playAnimation(animationName) {

				// Повторный клик по выбранной анимации - запуск с начала (props проигрывателя не меняются)
				if (animationName === this.selectedAnimation) this.restartAnimation();
				else this.selectedAnimation = animationName;

				this.playing = true;

				this.saveSelection();

			},
			restartAnimation() {

				this.$refs.player?.restart();

			},
			saveSelection() {

				Asset.SpineSelections[this.getSelectionKey()] = {
					skin: this.selectedSkin,
					animation: this.selectedAnimation
				};

			}
		}
	}
</script>

<style lang="sass">

	.spine-asset-settings
		display: flex
		flex-direction: column
		width: 100%

		.spine-asset-settings-info
			display: flex
			flex-wrap: wrap
			gap: 4px 12px
			margin-bottom: 8px
			font-size: 0.75rem
			color: #73818f

		.spine-asset-settings-preview
			display: flex
			justify-content: center
			margin-bottom: 8px

			.spine-player
				border-radius: 4px
				background: repeating-conic-gradient(#3a4248 0% 25%, #2f353a 0% 50%) 50% / 16px 16px

		.spine-asset-settings-controls
			display: flex
			align-items: center
			margin-bottom: 10px

			.spine-asset-settings-button
				display: flex
				align-items: center
				justify-content: center
				width: 26px
				height: 22px
				margin-right: 6px
				border-radius: 0.2rem
				cursor: pointer
				color: rgba(255, 255, 255, 0.87)
				background-color: rgba(255, 255, 255, 0.05)
				border: 1px solid rgba(255, 255, 255, 0.09)

				&:hover
					border-color: #4dbd74

			.spine-asset-settings-loop
				display: flex
				align-items: center
				margin-left: auto

				.title
					margin-right: 8px

				.switch
					margin: 0

		.spine-asset-settings-section
			margin-bottom: 10px

			.spine-asset-settings-section-title
				margin-bottom: 5px
				font-size: 0.75rem
				text-transform: uppercase
				color: #73818f

		.spine-asset-settings-skins
			display: flex
			flex-wrap: wrap
			gap: 4px

			.spine-asset-settings-skin
				padding: 1px 8px
				border-radius: 0.2rem
				cursor: pointer
				font-size: 0.8rem
				background-color: rgba(255, 255, 255, 0.05)
				border: 1px solid rgba(255, 255, 255, 0.09)

				&:hover
					border-color: #4dbd74

				&.selected
					background-color: #4dbd74
					border-color: #4dbd74
					color: #fff

		.spine-asset-settings-animations
			display: flex
			flex-direction: column
			max-height: 220px
			overflow-y: auto

			.spine-asset-settings-animation
				display: flex
				align-items: center
				padding: 2px 6px
				border-radius: 0.2rem
				cursor: pointer
				font-size: 0.8rem

				&:hover
					background-color: rgba(255, 255, 255, 0.05)

				&.selected
					background-color: rgba(77, 189, 116, 0.2)

					i
						color: #4dbd74

				i
					margin-right: 8px
					color: #73818f

				.spine-asset-settings-animation-name
					flex: 1
					overflow: hidden
					text-overflow: ellipsis
					white-space: nowrap

				.spine-asset-settings-animation-duration
					margin-left: 8px
					color: #73818f

		.spine-asset-settings-empty
			font-size: 0.8rem
			color: #73818f

</style>
